/*******************************************************************************
 * Project：
 * Summary:
 *　　 PhoneNumberComponent
 * Remarks:
 *     phone number component
 * History：
 *      NghiaNX            2021/05/26    Create
 ******************************************************************************/
import { Component, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Utility } from '../../utility/utility';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnChanges {

  @Input() inValue: string;
  @Input() length: number;
  @Input() setReadonly = false;
  @Input() ngClassName: string;
  @Input() isError = false;
  @Input() strId: string;
  @Output() newItemEvent = new EventEmitter();
  @Output() removeErrorEvent = new EventEmitter();
  strModel: string;
  keyValues = '';
  regHaftWidth = /^[0-9]*$/;
  constructor(
    public ulti: Utility,
    public trans: TranslateService,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.ulti.isNullOrEmpty(changes) && !this.ulti.isNullOrEmpty(changes.inValue)) {
      if (!this.ulti.isNullOrEmpty(changes.inValue.currentValue) && (changes.inValue.currentValue !== changes.inValue.previousValue)) {
        this.strModel = this.showForm(changes.inValue.currentValue.trim());
      } else if (this.ulti.isNullOrEmpty(changes.inValue.currentValue)) {
        this.strModel = '';
      }
    }
    if (!this.ulti.isNullOrEmpty(changes) && !this.ulti.isNullOrEmpty(changes.isError)) {
      this.isError = changes.isError.currentValue;
    }
  }
  onKeyTodo(event: any) {
    sessionStorage.removeItem('isSelectResCode');
    this.keyValues = event.target.value;
    let isHaftWidth = true;
    // start - Switch input
    isHaftWidth = this.check1ByteFunc(this.keyValues);
    if (!isHaftWidth) {
      event.target.value = this.keyValues.slice(0, -1);
      this.strModel = this.keyValues.slice(0, -1);
    }
    if (!this.ulti.isNullOrEmpty(this.strModel)) {
      this.removeErrorEvent.emit();
    }
  }
  check1ByteFunc(val: any) {
    let isHaftWidth = true;
    // Function to Check width reg
    const reg = new RegExp(this.regHaftWidth);
    if (!reg.test(val)) {
      isHaftWidth = false;
    }
    return isHaftWidth;
  }

  countLength(str: string) {
    let r = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
        r += 1;
      } else {
        r += 2;
      }
    }
    return r;
  }
  showForm(value: string) {
    return this.ulti.setAreaNumber(value);
  }
  focusIn(value: string) {
    this.strModel = value.replace(/\s/g, '');
  }
  focusOut(value: string) {
    let strHaftWidth = '';
    for (let i = 0; i < value.length; i++) {
      const char = value.charAt(i);
      const reg = new RegExp(this.regHaftWidth);
      if (reg.test(char)) {
        strHaftWidth += char;
      }
    }
    if (this.ulti.isNullOrEmpty(strHaftWidth)) {
      this.strModel = '';
    } else {
      this.strModel = this.showForm(strHaftWidth);
    }
    const phoneValue = this.strModel.replace(/\s/g, '');
    this.newItemEvent.emit(phoneValue);
  }
}

